// extracted by mini-css-extract-plugin
export default {"root":"PageHeading_root__whwYz","heading":"PageHeading_heading__ewceW","button":"PageHeading_button__3pSNL"};